module.exports = __webpack_public_path__ + "img/safe.f0a0dfdb.png";